/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetAccountStatuses200ResponseSystemStatuses } from './GetAccountStatuses200ResponseSystemStatuses';
import {
    GetAccountStatuses200ResponseSystemStatusesFromJSON,
    GetAccountStatuses200ResponseSystemStatusesFromJSONTyped,
    GetAccountStatuses200ResponseSystemStatusesToJSON,
} from './GetAccountStatuses200ResponseSystemStatuses';

/**
 * 
 * @export
 * @interface GetAccountStatuses200Response
 */
export interface GetAccountStatuses200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetAccountStatuses200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetAccountStatuses200Response
     */
    message: string;
    /**
     * 
     * @type {GetAccountStatuses200ResponseSystemStatuses}
     * @memberof GetAccountStatuses200Response
     */
    systemStatuses: GetAccountStatuses200ResponseSystemStatuses;
}

/**
 * Check if a given object implements the GetAccountStatuses200Response interface.
 */
export function instanceOfGetAccountStatuses200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "systemStatuses" in value;

    return isInstance;
}

export function GetAccountStatuses200ResponseFromJSON(json: any): GetAccountStatuses200Response {
    return GetAccountStatuses200ResponseFromJSONTyped(json, false);
}

export function GetAccountStatuses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountStatuses200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'systemStatuses': GetAccountStatuses200ResponseSystemStatusesFromJSON(json['system_statuses']),
    };
}

export function GetAccountStatuses200ResponseToJSON(value?: GetAccountStatuses200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'system_statuses': GetAccountStatuses200ResponseSystemStatusesToJSON(value.systemStatuses),
    };
}

